// extracted by css-extract-rspack-plugin
export default {"docsLink":"pEwVVjf0SQFiOOej"};